import FilledInput from '@material-ui/core/FilledInput';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import { Tooltip, CssBaseline, TextField,InputBase } from "@material-ui/core";
import clsx from 'clsx';
import React,{useRef} from 'react';
import { useEffect } from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
  },
  input: {
    fontSize: "14px",
    color: "red",
  },
  inputMarginDense: {
    paddingTop: "6px",
  },
  labelRoot: {
    fontSize: "12px",
  },
  iconButtonRoot: {
    padding: "0 6px !important",
  },
  submitIcon: {
    "&:hover": {
      color: "#0072c6",
    },
  },
  cancelIcon: {
    "&:hover": {
      color: "red",
    },
  },
  inputLabelStyling:{
    width: '100%',
  },
  editableInputFocus:{
    fontFamily: "Open Sans !important",
    fontSize: "12px !important",
    fontWeight: "600 !important",
    lineHeight: "16px !important",
    marginBottom: "4px !important", 
    border: "1px solid rgba(0, 114, 206, 1) !important", 
    boxShadow: "none !important",
    "&:focus":{
      marginBottom: "4px !important", 
      border: "1px solid rgba(0, 114, 206, 1) !important", 
      boxShadow: "none !important"
    }
  }
}));

export default function EditableLabel(props) {
  const defaultLabel = props.defaultLabel;
  const classes = useStyles();
  
  const [value, setValue] = React.useState();

  const variant= props.variant || 'normal';

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    if(props?.default_value || props?.default_value === ""){
      setValue(props?.default_value)
    }
  }, [props?.default_value])

  const labelRef = useRef();
  const labelHandler = (e, action) =>{
    
      switch (action) {
        case "submit":
          setValue(e?.target?.value);
          props.setLabelHandler(e?.target?.value);
          break;

        case "cancel":
          break;

        default:
          break;
      }
  }

  const maxLength = props?.maxLength ? {maxLength: ""}: {maxLength: window?.psh_configs?.label_max_length}; 


  return (
    <>
      <CssBaseline />
      {
      props.editlabel === false ? (
        props.defaultLabel ? (
          props.defaultLabel
        ) : null
      ) :
       variant === "normal" ? (
        <TextField
          id="EditableLabel"
          aria-label={"Control Value1"}
          ref={labelRef}
          variant="outlined"
          autoFocus
          style={props.style}
          className={props.className + " " + classes.inputLabelStyling}
          defaultValue={value}
          inputProps={{
            className: classes.editableInputFocus,
            style: {minWidth: props?.minWidth,width:"fit-content"},...maxLength,
          }}
          onBlur={(e) => labelHandler(e, "submit")}
          onCopy={(evt) => evt.stopPropagation()}
        />
      ) : (
        <FormControl
          className={clsx(classes.margin, classes.textField)}
          size="small"
          fullWidth
        >
          <FilledInput
            autoFocus
            size="small"
            fullWidth
            className={{
              input: classes.input,
              inputMarginDense: classes.inputMarginDense,
            }}
            type="text"
            defaultValue={value}
            onBlur={(e) => labelHandler(e,"submit")}
            endAdornment={
              <InputAdornment position="end">
                <Tooltip title="Submit">
                  <IconButton
                    aria-label="Submit"
                    onClick={(e) => labelHandler(e, "submit")}
                    edge="end"
                    className={clsx(classes.iconButtonRoot, classes.submitIcon)}
                    
                  >
                    <DoneIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                  <IconButton
                    aria-label="Cancel"
                    onClick={(e) => labelHandler(e,"cancel")}
                    edge="end"
                    className={clsx(classes.iconButtonRoot, classes.cancelIcon)}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            }
          />
        </FormControl>
      )}
    </>
  );
}